import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Link, useNavigate } from "react-router-dom";
import { format, getHours } from "date-fns";
import ru from "date-fns/locale/ru";

import WrapperContainer from "../../components/WrapperContainer/WrapperContainer.jsx";
import Button from "../../components/Button/Button.jsx";

import ShimmerMultiLine from "../../components/Shimmer/ShimmerMultiLine.jsx";
import Error from "../../features/Error.jsx";

import { APP_ROUTES } from "../../router";
import { apiFetchStatusProcess, apiFetchProcess } from "../../api/methods/process.js";

import useRedirect from "../../hooks/useRedirect.js";
import actions from "../../store/actions.js";

import getTimeUtc5 from "../../utils/helpers/getTimeUtc5";
import { PROCESS_STATUS } from "../../utils/consts/processStatus";

const FinishHome = () => {
  const dispatch = useDispatch();
  const history = useNavigate();

  const { mobileConnectionInfo } = useSelector(state => state);
  const [processStatus, setProcessStatus] = useState(null);

  const [dateDeparture, setDateDeparture] = useState(null);
  const [isAutoAuth, setIsAutoAuth] = useState(false);

  const [isFetchData, setIsFetchData] = useState(false);
  const [hasError, setHasError] = useState(false);

  const redirect = useRedirect();

  useEffect(() => {
    const { apiKey } = mobileConnectionInfo;

    if (!apiKey) {
      history(APP_ROUTES.MOBILE_CONNECTION.START_ROUTE, { replace: true });
    }

    (async () => {
      try {
        const { hasAuth, seData } = await apiFetchProcess(apiKey, ["has_auth", "se_data"]);
        setIsAutoAuth(hasAuth);

        if (seData) {
          const date = getFormattedDate(seData);
          setDateDeparture(" " + date);
        }

        const processStatus = await apiFetchStatusProcess(apiKey);
        setProcessStatus(processStatus);

        setIsFetchData(true);
        redirect(processStatus);
      } catch {
        setHasError(true);
        history(APP_ROUTES.MOBILE_CONNECTION.START_ROUTE);
      }
    })();
  }, []);

  const getFormattedDate = seData => {
    let dateFormatted = "";
    const time = getTimeUtc5(seData);

    if (getHours(time) === 0) {
      dateFormatted = format(getTimeUtc5(seData), "d MMMM в течение дня", {
        locale: ru,
      });
    } else {
      dateFormatted = format(getTimeUtc5(seData), "d MMMM в HH:mm", {
        locale: ru,
      });
    }

    return dateFormatted;
  };

  const redirectAndResetData = () => {
    dispatch(actions.removeData());
    history(APP_ROUTES.MOBILE_CONNECTION.ROOT_ROUTE);
  };

  const redirectToAuth = () => window.open("https://login.ufanet.ru", "_blank");

  if (hasError) return <Error />;
  if (!isFetchData) return <ShimmerMultiLine count={2} />;

  return (
    <>
      <WrapperContainer gap="16" title="sm">
        Готово
      </WrapperContainer>

      {processStatus === PROCESS_STATUS.CLOSED_WITHOUT_SUPPORT && isAutoAuth && (
        <>
          <WrapperContainer gap="16" text="lg">
            Приятного пользования!
          </WrapperContainer>

          <WrapperContainer gap="16">
            <Button isStretch color="primary" onClick={redirectAndResetData}>
              Далее
            </Button>
          </WrapperContainer>
        </>
      )}

      {processStatus === PROCESS_STATUS.CLOSED_WITHOUT_SUPPORT && !isAutoAuth && (
        <>
          <WrapperContainer gap="24" text="lg">
            Для того, чтобы начать пользоваться Интернетом осталось его настроить.
            <br />
            Подключите кабель к роутеру/компьютеру и воспользуйтесь{" "}
            <Link
              to={"https://www.ufanet.ru/ufa/pages/ufa_mp_int_setup-connections_ufa/"}
              target="_blank"
              className="link"
            >
              <b>инструкцией</b>
            </Link>
            <br />
            Приятного пользования!
          </WrapperContainer>

          <WrapperContainer gap="16">
            <Button isStretch color="primary" size="xl" onClick={redirectToAuth}>
              Перейти к активации
            </Button>
          </WrapperContainer>

          <WrapperContainer gap="16">
            <Button
              isStretch
              color="secondary"
              size="xl"
              onClick={() =>
                history({
                  pathname: APP_ROUTES.MOBILE_CONNECTION.CHOICE_DEPARTURE_TIME,
                  search: "?from=finish",
                })
              }
            >
              Оформить выезд инженера
            </Button>
          </WrapperContainer>
        </>
      )}

      {processStatus === PROCESS_STATUS.AWAIT_DEPARTURE && !isAutoAuth && (
        <>
          <WrapperContainer gap="16" text="lg">
            Заявка успешно оформлена.
            <br />
            Инженер приедет к Вам<b>{dateDeparture}</b>.
          </WrapperContainer>

          <WrapperContainer gap="16">
            <Button isStretch color="primary" onClick={redirectAndResetData}>
              Далее
            </Button>
          </WrapperContainer>
        </>
      )}

      {processStatus === PROCESS_STATUS.AWAIT_DEPARTURE && isAutoAuth && (
        <>
          <WrapperContainer gap="16" text="lg">
            Заявка успешно оформлена.
            <br />
            Инженер приедет к Вам <b>{dateDeparture}</b>.<br />
            Услуга Интернет доступна уже сейчас! Приятного пользования!
          </WrapperContainer>

          <WrapperContainer gap="16">
            <Button isStretch color="primary" onClick={redirectAndResetData}>
              Далее
            </Button>
          </WrapperContainer>
        </>
      )}

      <WrapperContainer text="sm" className="text-color-dark-gray">
        Далее вы сможете управлять услугами через личный кабинет на сайте{" "}
        <Link to={"https://my.ufanet.ru/"} target="_blank" className="link">
          <b>my.ufanet.ru</b>
        </Link>{" "}
        или через мобильное приложение.
      </WrapperContainer>
    </>
  );
};

export default FinishHome;
